import React, {useState} from 'react';
import {Container, Grid, } from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {Delete } from '@material-ui/icons';
import Form from 'components/Form/FormTwoColumns';
import ApiServices from 'services/ApiServices';
import {showMessagePersonalizedPosition} from 'services/SweetAlert'
import Title from 'components/TitleWithIcon';
import DialogLoadingMessage from 'components/LoadingMessage/index'

function ComponenteCaptacionDeFallecidos(props) {
    let description = [
        {name: "- Antes de continuar, revise que la información que ingresó esté correcta.",},
        {name: "- Datos requeridos (*)."}
    ]    
    const classes = useStyles(),        
    [loading, setLoading] = useState({loading: false, title:''}),
    [data, setData] = useState(props.saveDatatoFormDeleteAndEdit);

    const catalogoMotivoRechazo = [
        {id: 1, name:'1. Folio mal consignado'},
        {id: 2, name:'2. Departamento mal consignado'},
        {id: 3, name:'3. Municipio mal consignado'},
        {id: 4, name:'4. CUI mal consignado'},
        {id: 5, name:'5. Cédula mal consignada'},
        {id: 6, name:'6. Fecha de defunción mal consignada'},
        {id: 7, name:'7. Datos del ciudadano mal consignados'},
    ]

    const EliminarRegistroFallecido= async ()=>{
        setLoading({loading: true, title: 'Eliminando registro de fallecido ...'})
        let saveData = {iddetalle: props.idRegistroRenap, password: elements.password.value, catalogoMotivo: elements.catalogoMotivo.value.id, observacion: elements.observacion.value}
        try{
            const response =  await ApiServices.captacionFallecidos.eliminarFallecido(saveData)
            if(response.error!==null){
                showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
            }else{
                Cancelar()
                props.actualizarTabla()
                showMessagePersonalizedPosition('success','¡BIEN!', response.data,'center')
            }   
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Oops! ',"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ',"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }
        }                 
        setLoading({loading: false, title: ''})
    }
        
    const Cancelar=()=>{
        props.cerrar()
    };    
    const [elements,setElements] = useState({
        titleFolio:{
            idelement: "titleFolio",title:'Datos Generales del Folio', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },    
            nrofolio: {
                idelement: "nrofolio",  value:data.nrofolio||'', label: "No. Folio *", pattern:"^[\\w1-9_Ññ-]{1,11}$", disabled: true,
                validators: ['required'], errorMessages:['Ingrese No. Folio, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
            año: {
                idelement: "año",  value:data.año, label: "Año de folio *", pattern:"^[0-9]{4,4}$", disabled: true,
                validators: ['required'], errorMessages:['Ingrese Año de Folio, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },            
            coddepto: {
                idelement: "coddepto", value: data.coddepto, label: "Departamento defunción*", pattern:"^[1-9][0-9]*$", validators: ['required'], disabled: true,
                errorMessages:['Seleccione el Departamento'], isError:false, elementType:'autocompleteV2', list: [],
            },
            codmunic: {
                idelement: "codmunic", value: data.codmunic, label: "Municipio defunción*", pattern:"^[1-9][0-9]*$", validators: ['required'], disabled: true,
                errorMessages:['Seleccione el Municipio'], isError:false, elementType:'autocompleteV2', list: [], 
            },
            codauxiliatura: {
                idelement: "codauxiliatura", value: data.codauxiliatura, label: "Auxiliatura ", pattern:"^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Seleccione auxiliatura'], isError:false, elementType:'autocompleteV2', list: [], disabled: true,
            },            
            fechainicio: { 
                idelement: "fechainicio", value: new Date(data.fechainicio), label: "Ingrese Fecha Inicio *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], disabled: true,
                errorMessages:['Ingrese Fecha Inicio'], isError:false, elementType:'date' 
            },            
            fechafinal: { 
                idelement: "fechafinal", value: new Date(data.fechafinal), label: "Ingrese Fecha Fin *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], disabled: true,
                errorMessages:['Ingrese Fecha Fin'], isError:false, elementType:'date' 
            },                                    
        titleRestoDeDatos:{
            idelement: "titleRestoDeDatos",title:'Ingrese el Resto de los Datos', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },
            nroboleta: {
                idelement: "nroboleta",  value: data.nroboleta||'', label: "No. Boleta *", pattern:"^[\\w1-9]{0,11}$", disabled: true,
                validators: ['required'], errorMessages:['Ingrese No. boleta, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            cui: {
                idelement: "cui",  value:data.cui||'', label: "Ingrese CUI del DPI *", pattern:"^[0-9]{0,13}$", disabled: true,
                validators: ['required'], errorMessages:['Ingrese CUI, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            nroorden: {
                idelement: "nroorden",  value:data.nroorden||'', label: "Ingrese No. orden de Cédula", pattern:"^[\\w0-9 _ÑñwáéíóúÁÉÍÓÚ.,!¡\"#$%&/()=¿?'@*-]{0,4}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese No. orden de Cédula, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            nroregistro: {
                idelement: "nroregistro",  value:data.nroregistro||'', label: "Ingrese No. registro de Cédula", pattern:"^[\\w1-9]{0,11}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese No. registro de Cédula, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            estado: {
                idelement: "estado",  value:data.estado||'', label: "Ingrese Estado *", pattern:"^[0-9]{0,2}$", disabled: true,
                validators: ['required'], errorMessages:['Ingrese Estado, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            fechanacimiento: { 
                idelement: "fechanacimiento", value: new Date(data.fechanacimiento), label: 'Ingrese Fecha Nacimiento', pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], 
                // idelement: "fechanacimiento", value: data.fechanacimiento, label: 'Ingrese Fecha Nacimiento', pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], 
                errorMessages:['Ingrese Fecha Nacimiento'], isError:false, elementType:'date' , disabled: true,
            },
            fechadefuncion: { 
                idelement: "fechadefuncion", value: new Date(data.fechadefuncion), label: "Ingrese Fecha Defunción *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], 
                // idelement: "fechadefuncion", value: data.fechadefuncion, label: "Ingrese Fecha Defunción *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], 
                errorMessages:['Ingrese Fecha Defunción'], isError:false, elementType:'date' , disabled: true,
            },
        titleDatosFallecidos:{
            idelement: "titleDatosFallecidos",title:'Ingrese los Datos del Fallecido', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },
            apellido1fallecido: {
                idelement: "apellido1fallecido",  value:data.apellido1fallecido||'', label: "Ingrese Primer Apellido *", pattern:"^([\\w_Ññ.-][\\w_ Ññ.-]*[\\w_Ññ.-]){1,25}$", disabled: true,
                validators: ['required'], errorMessages:['Ingrese Primer Apellido, sin espacios al inicio y final'], isError:false, elementType:'input',
            },
            apellido2fallecido: {
                idelement: "apellido2fallecido",  value:data.apellido2fallecido||'', label: "Ingrese Segundo Apellido", pattern:"^^([\\w_Ññ.-][\\w_ Ññ.-]*[\\w_Ññ.-]){0,25}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Segundo Apellido, sin espacios al inicio y final'], isError:false, elementType:'input',
            },
            apellido3fallecido: {
                idelement: "apellido3fallecido",  value:data.apellido3fallecido||'', label: "Ingrese Apellido de Casada", pattern:"^([\\w_Ññ.-][\\w_ Ññ.-]*[\\w_Ññ.-]){0,25}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Apellido de Casada, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            nombre1fallecido: {
                idelement: "nombre1fallecido",  value:data.nombre1fallecido||'', label: "Ingrese Primer nombre *", pattern:"^^([\\w_Ññ.-.\"\'][\\w_ Ññ.-.\"\']*[\\w_Ññ.-.\"\']){1,25}$$", disabled: true,
                validators: ['required'], errorMessages:['Ingrese Primer Nombre, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            nombre2fallecido: {
                idelement: "nombre2fallecido",  value:data.nombre2fallecido||'', label: "Ingrese Segundo nombre", pattern:"^([\\w_Ññ.-][\\w_ Ññ.-]*[\\w_Ññ.-]){0,25}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Segundo Nombre, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
        titleDatosDelPadre:{
            idelement: "titleDatosDelPadre",title:'Ingrese los Datos del Padre', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },
            apellido1padre: {
                idelement: "apellido1padre",  value:data.apellido1padre||'', label: "Ingrese Primer Apellido del Padre", pattern:"^^([\\w_Ññ.-][\\w_ Ññ.-]*[\\w_Ññ.-]){0,25}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Primer Apellido, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            apellido2padre: {
                idelement: "apellido2padre",  value:data.apellido2padre||'', label: "Ingrese Segundo Apellido del Padre", pattern:"^^([\\w_Ññ.-][\\w_ Ññ.-]*[\\w_Ññ.-]){0,25}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Segundo Apellido, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            nombrepadre: {
                idelement: "nombrepadre",  value:data.nombrepadre||'', label: "Ingrese Nombres del Padre", pattern:"^([\\w_Ññ.-][\\w_ Ññ.-]*[\\w_Ññ.-]){0,30}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Nombres del Padre, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
        titleDatosDeLaMadre:{
            idelement: "titleDatosDeLaMadre",title:'Ingrese los Datos de la Madre', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },
            apellido1madre: {
                idelement: "apellido1madre",  value:data.apellido1madre||'', label: "Ingrese Primer Apellido de la Madre", pattern:"^^([\\w_Ññ.-][\\w_ Ññ.-]*[\\w_Ññ.-]){0,25}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Primer Apellido, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            apellido2madre: {
                idelement: "apellido2madre",  value:data.apellido2madre||'', label: "Ingrese Segundo Apellido de la Madre", pattern:"^^([\\w_Ññ.-][\\w_ Ññ.-]*[\\w_Ññ.-]){0,25}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Segundo Apellido, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            nombremadre: {
                idelement: "nombremadre",  value:data.nombremadre||'', label: "Ingrese Nombres de la Madre", pattern:"^([\\w_Ññ.-][\\w_ Ññ.-]*[\\w_Ññ.-]){0,30}$", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Nombres de la Madre, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
        titleObservacion:{
            idelement: "titleObservacion",title:'Ingrese Motivo de eliminación del registro', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],            
        },
            catalogoMotivo: {
                idelement: "catalogoMotivo", value: null, label: "Catálogo motivo de rechazo *", pattern:"^[0-9]*$", validators: ['required'], disabled: false,
                errorMessages:['Seleccione el Motivo de rechazo'], isError:false, elementType:'autocompleteV2', list: catalogoMotivoRechazo,
            },
            observacion: { 
                idelement: "observacion",  value:'', label: "Ingrese motivo", pattern:"^[\\w1-9 _ÑñwáéíóúÁÉÍÓÚ.,!¡\"#$%&/()=¿?'@*-]{0,50}$", validators: ['requireds'], 
                errorMessages:['Máximo 50 carácteres'], isError:false, elementType:'textArea', disabled: false,
            },
        firmaElectronica:{
            idelement: "firmaElectronica",title:'Ingrese Firma Electrónica', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },            
            password: { 
                idelement: "password",  value:'', label: 'Ingrese contraseña *', pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,20}$", validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password' ,
                disabled: false
            },
    });    
    
    const [buttonList,setButtonList]= React.useState({
        "eliminar":{"label":"Eliminar Registro","icon": <Delete />,"callback":EliminarRegistroFallecido, IsButtonCancelar: true, "loading":false, disabled: false},      
    });

    return (
        <div>
            <div className={classes.colorComponente}>
                <Grid container >
                    <DialogLoadingMessage open={loading.loading} title={loading.title}/>
                    <Title title="Datos del registro" icon={"/menu/Document.png"}/>
                    <Grid className={classes.AlignTable} item xs={12} direction="row" justify="center" alignItems="center"> <br/>
                    {
                        (props.saveDatatoFormDeleteAndEdit != {}) ?
                        <Form 
                            elements= {elements}  
                            buttonList={buttonList} 
                            BotonCerrar={Cancelar}
                            description={description}
                        />
                        :''
                    }
                    </Grid>           
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div><br/>
        </div>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(ComponenteCaptacionDeFallecidos);